import React from 'react';
import About from '../About/About';

import Services from '../Services/Services';

const Home = () => {
    return (
        <div>
            
            <About></About>
            <Services></Services>
        </div>
    );
};

export default Home;